// extracted by css-extract-rspack-plugin
export default {"input":"m9E8I"};